const VARIANTS = {
    OUTLINED: 'outlined',
    PRIMARY: 'primary',
    SECONDARY: 'secondary',
    TEXT: 'text',
};

export { VARIANTS };
//# sourceMappingURL=variants.js.map
